export default {
  sortedMembers(joined) {
    return joined.members
      .map((m, i) => ({...m, ...{index: i}}))
      .sort((a, b) => this.displayOrder(joined, a) - this.displayOrder(joined, b))
  },
  displayOrder(joined, m) {
    if (joined.displayOrder == 'display') return m.displayOrder
    if (joined.displayOrder == 'joined') return m.joinedOrder
    return m.index  // if manual sort
  },
  questHostOrder(joined, m) {
    if (joined.questHostOrder == 'display') return m.displayOrder
    if (joined.questHostOrder == 'joined') return m.joinedOrder
    return m.index  // if manual sort
  }
}
